import { extractApiMessage, statusFallbackMessage } from './api-message';

export class ApiError extends Error {
  constructor(errorData) {
    super();
    this.errorData = errorData;
  }

  getStatusCode() {
    return this.errorData?.Result?.StatusCode ?? this.errorData?.StatusCode;
  }

  getMessage() {
    return extractApiMessage(this.errorData);
  }

  getDisplayMessage() {
    return this.getMessage() ?? statusFallbackMessage(this.getStatusCode());
  }
}

export class LogActivityError extends ApiError {
  constructor(errorData) {
    super(errorData);
  }
}
